import React from "react";
import { Link } from "react-router-dom";
import { SERVICES, WA_LINKS } from "../../data/siteData";

const NAV_GROUPS = [
  {
    title: "Navigate",
    links: [
      { label: "Home", to: "/" },
      { label: "Services", to: "/services" },
      { label: "Case Studies", to: "/case-studies" },
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Services",
    links: SERVICES.map((s) => ({ label: s.shortName, to: `/services/${s.slug}` })),
  },
];

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-[#0A192F] text-[#C0C0C0] border-t border-[#C0C0C0]/15"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
        <div className="md:col-span-5">
          <img
            src="/assets/axis-logo-light.png"
            alt="AXIS Business Solutions"
            className="h-14 w-auto"
          />
          <p className="mt-5 text-sm text-[#94A3B8] max-w-md leading-relaxed">
            AXIS Business Solutions helps organizations improve digital visibility, create
            recognizable character brands, and strengthen customer experience.
          </p>
          <div className="mt-6 flex items-center gap-2">
            <span className="h-px w-8 bg-[#D4AF37]" />
            <span className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] font-semibold">
              AI Optimization. Human Judgment.
            </span>
          </div>
        </div>

        {NAV_GROUPS.map((group) => (
          <div key={group.title} className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-white font-semibold mb-5">
              {group.title}
            </div>
            <ul className="space-y-3">
              {group.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-$/, "")}`}
                    className="text-sm text-[#C0C0C0] hover:text-[#D4AF37] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="md:col-span-1 flex md:justify-end">
          <a
            href={WA_LINKS.recommend}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cta"
            className="inline-flex items-center gap-1 text-sm font-semibold text-[#D4AF37] border-b border-[#D4AF37] pb-1 hover:text-white hover:border-white transition-colors h-fit whitespace-nowrap"
          >
            Start →
          </a>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-[#C0C0C0]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="text-xs text-[#94A3B8]">
          © {new Date().getFullYear()} AXIS Business Solutions. All rights reserved.
        </div>
        <a
          href={WA_LINKS.recommend}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-recommendation-cta"
          className="text-xs font-semibold text-[#D4AF37] hover:text-white transition-colors"
        >
          Get My AXIS Recommendation →
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
